import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";

interface MeterTypesCardProps {
  meterTypePercentages?: Record<string, number>;
  title?: string;
  description?: string;
}

export const MeterTypesCard = ({
  meterTypePercentages,
  title = "",
  description = "",
}: MeterTypesCardProps) => {
  return (
    <Card className="transition-all duration-300 hover:shadow-xl hover:scale-102 focus-within:shadow-2xl focus-within:ring-2 focus-within:ring-accent">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4">
          {meterTypePercentages &&
          Object.keys(meterTypePercentages).length > 0 ? (
            Object.entries(meterTypePercentages).map(([key, value]) => (
              <div key={key}>
                <div className="flex justify-between mb-2">
                  <span className="text-sm">{key}</span>
                  <span className="text-sm font-medium">{value ?? "NA"}%</span>
                </div>
                <Progress value={value} className="h-2" />
              </div>
            ))
          ) : (
            <div className="text-sm text-muted-foreground mt-5">
              No data available.
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
